/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownIcon16Regular = forwardRef('ArrowShapeADownIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.587 14.396a2 2 0 0 0 2.828 0l5.689-5.689c.63-.63.183-1.707-.707-1.707H12V2.75A1.75 1.75 0 0 0 10.25 1h-4.5A1.75 1.75 0 0 0 4 2.75V7H1.604C.713 7 .266 8.077.897 8.707l5.69 5.69Zm1.767-1.06a.5.5 0 0 1-.707 0L2.811 8.5H4.75a.75.75 0 0 0 .75-.75v-5a.25.25 0 0 1 .25-.25h4.5a.25.25 0 0 1 .25.25v5c0 .414.336.75.75.75h1.94l-4.836 4.836Z" })));
});
